import { type ApiService } from '@/core/http/services/ApiService'
import type { AxiosResponse } from 'axios'
import type { Customer } from '@/core/http/services/customers/types'
import type { PaginatedResponse } from '@/core/http/services/types'

export class CustomerService {
  constructor(private readonly service: ApiService) {
    //
  }

  public async index(
    query: string,
    page = 1,
  ): Promise<AxiosResponse<PaginatedResponse<Customer[]>>> {
    return this.service.client.get('api/customers', { params: { query, page } })
  }
}
